<template>
    <div class="cliente" app>
        <Navbar/>
        
        <v-content>
            <v-overlay
                absolute
                :value="loading"
                class="text-center"
            >
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-overlay>
            <v-row align="center" justify="center" style="padding: 16px 16px; margin-top: 30px">
                <v-col cols="12" sm="11" md="10">
                    <v-card style="overflow-x:hidden" flat :dark="customization.dark">
                        <v-alert 
                            type="error"
                            :value="alert.length > 0"
                            :dark="customization.dark">
                            {{alert}}
                        </v-alert>
                        <v-form :id="`${nameType}_form`">
                            <h1 style="padding: 16px 16px">{{`Inserir ${title}`}}</h1>
                            <v-row align="center" justify="center" style="padding: 16px 16px">
                                <v-col 
                                    v-for="col in cols"
                                    :key="col.value"
                                    :cols="col.cols"
                                    :sm="col.sm"
                                    :md="col.md"
                                    align="center"
                                >
                                    <v-text-field
                                        v-if="col.type == 'text'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                        :maxlength="col.length ? col.length : null"
                                        :counter="col.length"
                                        outlined
                                        @change="verify(col.verify,col.value)"
                                        :error="col.verify && verification[col.value]"
                                    ></v-text-field>
                                    <v-select
                                        v-if="col.type == 'select'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :items="Object.keys(col.items)"
                                        :name="col.value"
                                        outlined
                                    ></v-select>
                                    <v-color-picker
                                        :style="'position: absolute; margin-top: 55px; background-color: #323232; z-index: 1000000; display: '+colorDisplay"
                                        v-if="col.type == 'color'"
                                        absolute
                                        v-model="color"
                                        mode="hexa"
                                        hide-inputs
                                    >
                                    </v-color-picker>
                                    <v-text-field
                                        v-if="col.type == 'color'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        v-model="color.hex"
                                        :rules="col.required ? requireRule : []"
                                        @focus="colorDisplay = 'block'"
                                        @blur="colorDisplay = 'none'"
                                        outlined
                                    ></v-text-field>
                                    <v-checkbox
                                        v-if="col.type == 'check'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                    ></v-checkbox>
                                    <v-text-field 
                                        v-if="col.type == 'date'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        type="date"
                                        outlined >
                                    </v-text-field>
                                    <v-text-field 
                                        v-if="col.type == 'time'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        type="time"
                                        outlined >
                                    </v-text-field>
                                    <v-text-field 
                                        v-if="col.type == 'password'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        type="password"
                                        :maxlength="col.length ? col.length : null"
                                        :counter="col.length"
                                        outlined >
                                    </v-text-field>
                                    <v-text-field 
                                        v-if="col.type == 'number'"
                                        :rules="col.required ? requireRule : []"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        type="number"
                                        outlined >
                                    </v-text-field>
                                    <Autocomplete
                                        v-if="col.type == 'autocomplete'"
                                        :required="col.required"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :dark="customization.dark"
                                        :needWhere="col.autocomplete.needWhere"
                                        :url="col.autocomplete.url"
                                        :iddisplay="col.autocomplete.display"
                                        :idvalue="col.autocomplete.value"
                                        outlined >
                                    </Autocomplete>
                                    <Grid
                                        v-if="col.type == 'grid'"
                                        :customization="customization" 
                                        :headers="col.grid.headers"
                                        :editable="true"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :needClient="col.grid.needClient">
                                    </Grid>
                                    <v-textarea
                                        v-if="col.type == 'textarea'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :rules="col.required ? requireRule : []"
                                        :maxlength="col.length ? col.length : null"
                                        :counter="col.length"
                                        outlined
                                    ></v-textarea>
                                    <File
                                        v-if="col.type == 'fileIcon'"
                                        :label="col.required ? col.text+'*' : col.text"
                                        :name="col.value"
                                        :dark="customization.dark"
                                        :mainColor="customization.mainBtnColor"
                                        outlined
                                    ></File>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color='red'
                    style="bottom: 85px"
                    v-on="on"
                    @click="back"
                    >
                        <v-icon>mdi-cancel</v-icon>
                    </v-btn>
                </template>
                <span>Cancelar</span>
            </v-tooltip>

            <v-tooltip left>
                <template v-slot:activator="{ on }">
                    <v-btn
                    fixed
                    dark
                    fab
                    right
                    color="green"
                    style="bottom: 15px"
                    v-on="on"
                    @click="salvar"
                    >
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                </template>
                <span>Salvar</span>
            </v-tooltip>
        </v-content>
    </div>
</template>

<script>
import Autocomplete     from '@/components/Autocomplete.vue';
import Grid             from '@/components/Grid.vue';
import Navbar           from '@/components/Navbar.vue';
import File             from '@/components/File.vue';
import api              from '@/plugins/apisauceHeader.js';
import router           from '@/router/index.js';
import CRUD             from '@/assets/CRUD.json';

export default {
    name: 'Create',
    components:{
        Navbar,
        Grid,
        Autocomplete,
        File
    },
    data(){
        return{
            id: this.$route.params.id,
            clienteSelecionado: {},
            alert: "",
            requireRule:[
                r => (r && r.toString().length > 0 ) || "Essa campo é obrigatório!",
            ],
            loading: false,
            dialog_remove: false,
            customization: {},
            nameType: "",
            cols: [],
            color: {hex:"#ffffff"},
            colorDisplay: "none",
            title: "",
            verification: {}
        }
    },
    methods:{
        verify(value,name){
            if(value){
                const val = document.getElementsByName(name)[0].value;
                api(localStorage.getItem("token")).get(`endpoint/${CRUD[this.nameType].verifyEndpoint}/addwhere=idcliente:${localStorage.getItem("idcliente")},${name}:${val}?noPagination=true`).then(r=>{
                    if(r.ok){
                        if(r.data.endpoint.length > 0){
                            this.alert = `O campo ${name.toUpperCase()} já foi cadastrado no sistema`;
                            window.scrollTo(0,0);
                            this.verification[name] = true;
                        }else{
                            this.alert = ``;
                            this.verification[name] = false;
                        }
                    }
                })
            }
        },
        back(){
            router.push(`/CRUD/${this.nameType}`);
        },
        salvar(){
            const form = document.getElementById(`${this.nameType}_form`);
            const rows = {};
            let p = true;
            let grids = [];
            let gridsUrl = [];

            if(Object.keys(this.verification).map(m=>this.verification[m]).includes(true)) return;

            if(!CRUD[this.nameType].noUUID)
                rows[CRUD[this.nameType].id] = "#uuid()";

            this.cols.forEach(c=>{
                if(c.required && form[c.value].value == ""){ 
                    p = false;
                    if(c.type == "select")
                        form[c.value].click();
                    else if(c.type == "autocomplete"){
                        form[c.value+"_input"][0].click();
                        this.alert = "Você precisa preencher o campo "+c.value;
                        window.scrollTo(0,0);
                    }
                    else
                        form[c.value].focus();
                }
                switch(c.type){
                    case "check":
                        if(c.value == "deletado_veiculo")
                            rows["deletado"] = (form[c.value].checked ? "Sim" : "Não");
                        else
                            rows[c.value] = (form[c.value].checked ? "1" : "0");
                    break;
                    case "select":
                        rows[c.value] = `${c.items[form[c.value].value]}`;
                    break;
                    case "grid":
                        grids.push(JSON.parse(form[c.value].value));
                        gridsUrl.push({url: c.grid.url, id_rel: c.grid.id_rel, id: c.grid.id});
                    break;
                    case "number":
                        rows[c.value] = rows[c.value] != "" ? `${form[c.value].value}` : `null`;
                    break;
                    default:
                        rows[c.value] = `${form[c.value].value}`;
                        if(c.type == "autocomplete" && form[c.value].value == "")
                            delete rows[c.value];
                    break;
                }
            })

            if(CRUD[this.nameType].needWhere)
                rows['idcliente'] = localStorage.getItem("idcliente");
            if(this.nameType == "funcionarios")
                rows['funcionario'] = 1;

            if(p){
                this.loading = true;
                api(localStorage.getItem("token")).post(`endpoint${CRUD[this.nameType].endpoint}/`,rows).then(r=>{
                    if(r.ok)
                        this.applyGrid(gridsUrl,grids,0,r.data[0][CRUD[this.nameType].id],0);
                    else{
                        this.alert = r.data.mensagem; 
                        this.loading = false;
                    }
                });
            }
        },
        applyGrid(gridsUrl,grids,n,id,i){
            console.log(id);
            if(n >= grids.length){
                this.loading = false;
                this.back();
            }else{
                if(grids[n].length > 0){
                    if(i < grids[n].length){
                        const rows = grids[n][i];
                        let url = gridsUrl[n].url;
                        rows[gridsUrl[n].id] = "#uuid()";
                        rows[gridsUrl[n].id_rel] = id;
                        if(rows['idmotorista_grid']){
                            rows['idmotorista'] = rows['idmotorista_grid'];
                            delete rows['idmotorista_grid'];
                        }
                        api(localStorage.getItem("token")).post(`endpoint/${url}/`,rows).then(r=>{
                            if(r.ok)
                                this.applyGrid(gridsUrl,grids,n,id,i+1);
                            else{
                                this.alert =  "Erro ao salvar a grid! verifique se todos os campos estão preenchidos!";
                                this.loading = false;
                                window.scrollTo(0,0);
                            }
                        });
                    }else 
                        this.applyGrid(gridsUrl,grids,n+1,id,0);
                }else 
                    this.applyGrid(gridsUrl,grids,n+1,id,0);
            }
        }
    },
    mounted(){
        this.customization = JSON.parse(localStorage.getItem("customization"));
        this.nameType = this.$route.params.nameType;
        if(!CRUD[this.nameType]) router.push('/dashboard');

        this.title = `${CRUD[this.nameType].label ? CRUD[this.nameType].label : this.nameType}`;
        document.title = `${this.customization.name} - Inserir ${this.title}`;
        if(!localStorage.getItem("usrId")) router.push('/');
        this.cols = CRUD[this.nameType].cols;
    }
}
</script>